export default function getBackgroundColor(theme: any) {
  return theme.palette.getContrastText(theme.palette.primary.main) === '#fff'
    ? theme.palette.primary.light
    : theme.palette.primary.dark;
}
